






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataDesc } from '../../../classes';

import { WxIDataDialog } from './WxIDataDialog';

@Component({ name: 'wxDataDialog' })
export default class WxDataDialog extends Vue implements WxIDataDialog {
    @Prop(Object) public readonly dataDesc!: DataDesc;
    @Prop(String) private titleItemName!: string;
    @Prop(Object) private readonly selectedItem!: any;
    @Prop(Object) private readonly defaultItem!: any;

    private show = false;

    private insertTitlePattern = '$common.INSERT_ITEM';
    private updateTitlePattern = '$common.UPDATE_ITEM';

    private isInsert = true;

    private editedItem = Object.assign({}, this.defaultItem);

    private get titlePattern() {
        return this.isInsert ? this.insertTitlePattern : this.updateTitlePattern;
    }

    /*
        v-on:widget-created="hndlConfigWidget"

    private hndlConfigWidget(widget: any) {
        if (!!widget && !!this.dataDesc) {
            widget.fieldDesc = this.dataDesc.fieldByName(widget.fieldName)!;
        }
    }
    */

    public showDialog(isInsert: boolean) {
        this.isInsert = isInsert;
        if (this.isInsert) {
            this.editedItem = Object.assign(this.editedItem, this.defaultItem);
        } else {
            this.editedItem = Object.assign(this.editedItem, this.selectedItem);
        }
        this.show = true;
    }

    @Watch('selectedItem', { immediate: true, deep: true })
    public onSelectedItemChanged(val: object) {
        this.editedItem = Object.assign(this.editedItem, val);
    }

    public closeDialog() {
        this.show = false;
    }

    private get form(): any {
        return this.$refs.form as any;
    }

    private hndlSave() {
        if (this.form.validate()) {
            this.$emit('onSave', this.editedItem, this.isInsert);
        }
    }

    @Watch('show')
    private onShowChanged(val: boolean) {
        if (!val) {
            this.dialogClosed();
        }
    }

    private dialogClosed() {
        setTimeout(() => {
            this.form.reset();
            for (const key of Object.keys(this.editedItem)) {
                this.editedItem[key] = undefined;
            }
        }, 300);
    }
}
